module.exports = __webpack_public_path__ + "img/ai-write.3f2a8c48.svg";